import { callPromiseAssert } from "../../shared/util/callPromiseAssert";
import { viewJobNativeModule } from "./ViewJobNativeModule";

export function httpGetJson<T>(url: string): Promise<T> {
  return callPromiseAssert(viewJobNativeModule()?.httpGetJson<T>, "httpGetJson", url);
}
